var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuLs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 19H41.2715C41.2715 19 48.0856 20.5264 48.6919 20.6629C49.2996 20.7984 49.4371 21.1547 49.335 21.6273C49.2364 22.0736 48.9106 23.5721 48.9106 23.5721L57 19ZM39.608 34.2998C39.5903 33.464 38.9259 33.288 37.7288 33.288L36.6195 33.282C31.1984 33.282 29.0967 31.1824 29.0967 28.4501C29.0967 25.7203 31.5486 21.8962 37.0091 21.8962H46.418C46.9291 21.8962 47.1405 22.109 46.9762 22.8442C46.8422 23.4266 46.1788 26.2142 46.1788 26.2142H38.5666C36.889 26.2142 35.6506 27.0374 35.6506 27.9824C35.6506 28.9283 36.7906 29.3115 37.9031 29.3115H41.0266C45.0969 29.3115 46.54 30.8524 46.4041 33.2307C46.1629 37.4681 43.392 40.998 36.3083 40.998H27.9485C27.6939 40.998 27.4144 40.7858 27.5383 40.224C27.6349 39.7946 28.2315 37.1538 28.4006 36.407V36.4055C28.3939 36.3638 28.3689 36.3944 28.3689 36.3944C28.3276 36.4885 28.2901 36.5634 28.231 36.6781C27.1641 38.7556 24.5291 41 22.5639 41H14.7984C11.8671 41 10.5513 38.5665 11.1359 35.9011L14.2373 22.5002C14.3512 22.029 14.4929 21.9148 14.8724 21.9148H20.5285L17.2566 36.2124H34.1888C37.6183 36.2124 38.2615 36.1505 38.9927 35.5596C39.3164 35.2976 39.6167 34.761 39.608 34.2998Z",
    fill: "#95A1C6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuLs);
export default __webpack_public_path__ + "static/media/leftmenu_LS.b50cac111372acccf4a294eb6ba00afa.svg";
export { ForwardRef as ReactComponent };